module.exports = __webpack_public_path__ + "img/rejected_light.7e17be5e.svg";